import { attachmentsReducer } from "./+store/slices/attachments/attachments.slice";
import { NgModule } from "@angular/core";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { StoreModule } from "@ngrx/store";
import { currentMessageSliceKey } from "./+store/slices/current-message/current-message-slice.config";
import { currentMessageReducer } from "./+store/slices/current-message/current-message.slice";
import { attachmentsSliceKey } from "./+store/slices/attachments/attachments-slice.config";

@NgModule({
    imports: [StoreModule.forFeature(attachmentsSliceKey, attachmentsReducer), StoreModule.forFeature(currentMessageSliceKey, currentMessageReducer)],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class SharedApiKno2fyMainModule {}
